import { render } from "./orchestrate-nav-icon.vue.js?vue&type=template&id=5584cee8!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./orchestrate-nav-icon.vue?vue&type=template&id=5584cee8"
const script = {}

import exportComponent from "../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__